module.exports = __webpack_public_path__ + "img/lls.3d971fd0.png";